export default function burgerMenu() {
  const burger = document.querySelector('.js-burger');
  const menu = document.querySelector('.js-adaptive-menu');
  const closeMenu = document.querySelector('.js-close-menu');

  if ( !burger ) return;

  burger.addEventListener('click', () => {
    menu.style.display = 'block';
  });

  closeMenu.addEventListener('click', () => {
    menu.style.display = 'none';
  })
}
